'use strict';

var React = require('react');
module.exports = function () {
  return React.createElement('svg', { width: '25', height: '25', viewBox: '0 0 25 25' }, React.createElement('path', { d: 'M11.793 12.5L8.146 8.854 7.793 8.5l.707-.707.354.353 3.646 3.647 3.646-3.647.354-.353.707.707-.353.354-3.647 3.646 3.647 3.646.353.354-.707.707-.354-.353-3.646-3.647-3.646 3.647-.354.353-.707-.707.353-.354 3.647-3.646z' }));
};


// WEBPACK FOOTER //
// ./~/wix-base-ui/lib/panels/headerCloseButton.svg.js